import { useState, useMemo, useCallback } from 'react'
import { useGlobalEvLog } from '../../store/eventLog.js'
import { fmtDate } from '../../data/seed.js'
import { GhostBtn } from '../shared/ui.jsx'

function AuditoriaTab(){
  const [evLog]=useGlobalEvLog();
  const [filtroTipo,setFiltroTipo]=useState("all");
  const [filtroUsuario,setFiltroUsuario]=useState("all");
  const [filtroEntidade,setFiltroEntidade]=useState("all");
  const [filterDataDe,setFilterDataDe]=useState("");
  const [filterDataAte,setFilterDataAte]=useState("");
  const [busca,setBusca]=useState("");

    const LABEL_EVENTO={
    "CADASTRO":             "Cadastro",
    "ENTRADA":              "Entrada",
    "SAIDA":                "Saída",
    "TRANSFERENCIA":        "Transferência",
    "AJUSTE":               "Ajuste",
    "EDIÇÃO":               "Edição",
    "EDICAO":               "Edição",
    "EDIÇÃO SENSÍVEL":      "Edição Sensível",
    "EDICAO SENSIVEL":      "Edição Sensível",
    "SKU_MANUAL":           "SKU Manual",
    "STATUS_FORCADO":       "Status Forçado",
    "STATUS_NF":            "Status NF",
    "TENTATIVA_INVALIDA":   "Tentativa Inválida",
    "DEMANDA_RESOLVIDA":    "Demanda Resolvida",
    "ITEM_RESTAURADO":      "Item Restaurado",
    "ESTOQUE_ZERADO_MANUAL":"Estoque Zerado",
    "ITEM_ARQUIVADO":       "Item Arquivado",
    "NF_MANUAL":            "NF Manual",
    "DEMANDA_CRIADA":           "Demanda Criada",
    "EXPORTACAO_PLANILHA":      "Exportação Planilha",
    "ITEM_NAO_CONTABILIZADO":   "Item Não Contabilizado",
    "REIMPORTACAO":             "Reimportação",
    "NOTIFICACAO_DEMANDA":      "Notificação de Demanda",
    "NOTIFICACAO_SISTEMA":      "Notificação do Sistema",
    "RESPOSTA_DEMANDA":         "Resposta de Demanda",
    "ITEM_EXCLUIDO":            "Item Excluído",
  };
  const labelEvento=(tipo)=>LABEL_EVENTO[tipo]||tipo;
  const LABEL_ENTIDADE={
    "PRODUTO":  "Produto",
    "DEMANDA":  "Demanda",
    "NF":       "Nota Fiscal",
    "ROTA":     "Rota",
    "SISTEMA":  "Sistema",
  };
  const labelEntidade=(e)=>LABEL_ENTIDADE[e]||e;
  const tiposUnicos=[...new Set(evLog.map(e=>e.tipo_evento))].sort();
  const usuariosUnicos=[...new Set(evLog.map(e=>e.usuario))].sort();
  const entidadesUnicas=[...new Set(evLog.map(e=>e.entidade))].sort();

  const filtered=useMemo(()=>{
    const term=busca.trim().toLowerCase();
    return evLog.filter(e=>{
      if(filtroTipo!=="all"&&e.tipo_evento!==filtroTipo)return false;
      if(filtroUsuario!=="all"&&e.usuario!==filtroUsuario)return false;
      if(filtroEntidade!=="all"&&e.entidade!==filtroEntidade)return false;
      const ts=e.timestamp?.slice(0,10)||"";
      if(filterDataDe&&ts<filterDataDe)return false;
      if(filterDataAte&&ts>filterDataAte)return false;
      if(term){
        const haystack=[e.tipo_evento,e.usuario,e.entidade,e.id_entidade,e.detalhes,e.timestamp].filter(Boolean).join(" ").toLowerCase();
        if(!haystack.includes(term))return false;
      }
      return true;
    });
  },[evLog,filtroTipo,filtroUsuario,filtroEntidade,filterDataDe,filterDataAte,busca]);

  const clearFilters=()=>{setFiltroTipo("all");setFiltroUsuario("all");setFiltroEntidade("all");setFilterDataDe("");setFilterDataAte("");setBusca("");setPage(1);};

  const exportXLSX=()=>{
    const doExport=(XLSX)=>{
      const data=filtered.map(e=>({
        "Data/Hora":    e.timestamp?new Date(e.timestamp).toLocaleString("pt-BR"):"",
        "Tipo":         labelEvento(e.tipo_evento),
        "Tipo (raw)":   e.tipo_evento,
        "Usuário":      e.usuario||"",
        "Entidade":     labelEntidade(e.entidade),
        "SKU / ID":     e.id_entidade||"",
        "Detalhes":     e.detalhes||"",
        "Sensível":     isSensivel(e.tipo_evento)?"SIM":"",
      }));
      const ws=XLSX.utils.json_to_sheet(data);
      ws["!cols"]=[{wch:20},{wch:20},{wch:22},{wch:16},{wch:12},{wch:12},{wch:50},{wch:8}];
      const wb=XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,"Auditoria");
      XLSX.writeFile(wb,`auditoria_${new Date().toISOString().split("T")[0]}.xlsx`);
    };
    if(window.XLSX){doExport(window.XLSX);return;}
    const script=document.createElement("script");
    script.src="https://cdn.sheetjs.com/xlsx-0.20.3/package/dist/xlsx.full.min.js";
    script.onload=()=>doExport(window.XLSX);
    script.onerror=()=>alert("Erro ao carregar biblioteca de exportação.");
    document.head.appendChild(script);
  };
  const SEL={...{background:"var(--bg2)",border:"1px solid var(--border2)",borderRadius:2,padding:"7px 10px",fontSize:9,color:"var(--text)",fontFamily:"'Courier New',monospace",cursor:"pointer"}};

  const COR_EVENTO={
    "EDIÇÃO SENSÍVEL":"#ff4757",
    "EDICAO SENSIVEL":"#ff4757",
    "SKU_MANUAL":     "#ffa502",
    "STATUS_FORCADO": "#ffa502",
    "TENTATIVA_INVALIDA":"#ff4757",
    "STATUS_NF":      "#a78bfa",
    "CADASTRO":       "#00d084",
    "ENTRADA":        "#00d084",
    "SAIDA":          "#ff4757",
    "TRANSFERENCIA":  "#3b82f6",
    "AJUSTE":         "#ffa502",
    "EDIÇÃO":         "#3b82f6",
    "DEMANDA_RESOLVIDA":"#00d084",
    "ITEM_RESTAURADO":"#00d084",
    "ESTOQUE_ZERADO_MANUAL":"#ffa502",
    "ITEM_ARQUIVADO": "#a78bfa",
    "NF_MANUAL":      "#a78bfa",
    "DEMANDA_CRIADA": "#00d084",
    "EXPORTACAO_PLANILHA":"#3b82f6",
    "ITEM_NAO_CONTABILIZADO":"#ffa502",
    "REIMPORTACAO":   "#3b82f6",
    "NOTIFICACAO_DEMANDA": "#a78bfa",
    "NOTIFICACAO_SISTEMA": "#a78bfa",
    "ITEM_EXCLUIDO":   "#ff4757",
    "RESPOSTA_DEMANDA":    "#a78bfa",
  };
  const corEvento=(tipo)=>COR_EVENTO[tipo]||"var(--text4)";
  const isSensivel=(tipo)=>["EDIÇÃO SENSÍVEL","EDICAO SENSIVEL","TENTATIVA_INVALIDA","STATUS_FORCADO"].includes(tipo);
  const [expandido,setExpandido]=useState(null);
  const toggleExpandido=useCallback(id=>setExpandido(v=>v===id?null:id),[]);
  const [page,setPage]=useState(1);
  const PAGE_SIZE=50;
  const totalPages=Math.max(1,Math.ceil(filtered.length/PAGE_SIZE));
  const paginated=filtered.slice((page-1)*PAGE_SIZE,page*PAGE_SIZE);

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:8}}>
        <p style={{fontSize:9,letterSpacing:3,color:"var(--text4)"}}>TRILHA DE AUDITORIA — {filtered.length} evento(s)</p>
        <div style={{display:"flex",gap:8}}>
          <GhostBtn onClick={()=>{clearFilters();setPage(1);}} style={{fontSize:8,padding:"4px 10px"}}>LIMPAR FILTROS</GhostBtn>
          <button onClick={exportXLSX} style={{background:"none",border:"1px solid #00d08444",color:"#00d084",padding:"4px 12px",fontSize:8,letterSpacing:2,cursor:"pointer",borderRadius:2,fontFamily:"'Courier New',monospace"}}>↓ XLSX</button>
        </div>
      </div>

      {/* Busca livre */}
      <div style={{marginBottom:10}}>
        <input
          value={busca}
          onChange={e=>setBusca(e.target.value)}
          placeholder="Buscar por SKU, usuário, tipo, detalhes..."
          style={{width:"100%",boxSizing:"border-box",background:"var(--bg2)",border:"1px solid var(--border2)",borderRadius:2,padding:"10px 14px",fontSize:11,color:"var(--text)",fontFamily:"'Courier New',monospace",outline:"none"}}
          onFocus={e=>e.target.style.borderColor="#ffa502"}
          onBlur={e=>e.target.style.borderColor="var(--border2)"}
        />
      </div>

      {/* Filtros */}
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:16}}>
        <select value={filtroTipo} onChange={e=>{setFiltroTipo(e.target.value);setPage(1);}} style={SEL}>
          <option value="all">TODOS OS TIPOS</option>
          {tiposUnicos.map(t=><option key={t} value={t}>{labelEvento(t)}</option>)}
        </select>
        <select value={filtroUsuario} onChange={e=>{setFiltroUsuario(e.target.value);setPage(1);}} style={SEL}>
          <option value="all">TODOS OS USUÁRIOS</option>
          {usuariosUnicos.map(u=><option key={u} value={u}>{u}</option>)}
        </select>
        <select value={filtroEntidade} onChange={e=>{setFiltroEntidade(e.target.value);setPage(1);}} style={SEL}>
          <option value="all">TODAS AS ENTIDADES</option>
          {entidadesUnicas.map(e=><option key={e} value={e}>{labelEntidade(e)}</option>)}
        </select>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <input type="date" value={filterDataDe} onChange={e=>setFilterDataDe(e.target.value)} style={{...SEL,width:130}} placeholder="De"/>
          <span style={{fontSize:9,color:"var(--text4)"}}>até</span>
          <input type="date" value={filterDataAte} onChange={e=>setFilterDataAte(e.target.value)} style={{...SEL,width:130}} placeholder="Até"/>
        </div>
      </div>

      {filtered.length===0&&(
        <div style={{textAlign:"center",padding:"60px 0"}}>
          <div style={{fontSize:36,color:"var(--border2)",marginBottom:12}}>◎</div>
          <p style={{color:"var(--text5)",fontSize:11,letterSpacing:2}}>NENHUM EVENTO ENCONTRADO</p>
        </div>
      )}

      <div style={{display:"flex",flexDirection:"column",gap:6}}>
        {paginated.map(e=>{
          const exp=expandido===e.id;
          const sensivel=isSensivel(e.tipo_evento);
          return(
            <div key={e.id} style={{background:sensivel?"#ff475708":"var(--bg2)",border:`1px solid ${sensivel?"#ff475744":"var(--border)"}`,borderLeft:`3px solid ${corEvento(e.tipo_evento)}`,borderRadius:2,padding:"10px 14px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,flexWrap:"wrap"}}>
                <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                  <button onClick={()=>toggleExpandido(e.id)} style={{background:"none",border:"none",color:"var(--text5)",fontSize:9,cursor:"pointer",padding:0,lineHeight:1,flexShrink:0}}>
                    {exp?"▼":"▶"}
                  </button>
                  <span style={{fontSize:8,padding:"2px 8px",borderRadius:2,background:corEvento(e.tipo_evento)+"20",color:corEvento(e.tipo_evento),fontWeight:700,letterSpacing:1}}>{labelEvento(e.tipo_evento)}{isSensivel(e.tipo_evento)&&" ⚠"}</span>
                  <span style={{fontSize:9,color:"var(--text3)",fontWeight:600}}>{e.id_entidade}</span>
                  <span style={{fontSize:8,padding:"2px 7px",borderRadius:2,background:"var(--bg3)",color:"var(--text4)"}}>{e.entidade}</span>
                </div>
                <div style={{textAlign:"right",flexShrink:0}}>
                  <p style={{fontSize:8,color:"var(--text5)"}}>{e.usuario}</p>
                  <p style={{fontSize:8,color:"var(--text5)"}}>{e.timestamp?new Date(e.timestamp).toLocaleString("pt-BR"):""}</p>
                </div>
              </div>
              {exp&&(
                <div style={{marginTop:8,paddingTop:8,borderTop:"1px solid var(--border)",display:"flex",flexDirection:"column",gap:3}}>
                  <span style={{fontSize:8,color:"var(--text5)"}}>TIPO <span style={{color:"var(--text3)",fontFamily:"'Courier New',monospace"}}>{e.tipo_evento}</span></span>
                  <span style={{fontSize:8,color:"var(--text5)"}}>ENTIDADE <span style={{color:"var(--text3)"}}>{e.entidade} — {e.id_entidade}</span></span>
                  <span style={{fontSize:8,color:"var(--text5)"}}>USUÁRIO <span style={{color:"var(--text3)"}}>{e.usuario}</span></span>
                  <span style={{fontSize:8,color:"var(--text5)"}}>DATA/HORA <span style={{color:"var(--text3)"}}>{e.timestamp?new Date(e.timestamp).toLocaleString("pt-BR"):""}</span></span>
                  {e.detalhes&&<span style={{fontSize:8,color:"var(--text5)"}}>DETALHES <span style={{color:"var(--text3)",lineHeight:1.6}}>{e.detalhes}</span></span>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    {totalPages>1&&(
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:16,paddingTop:12,borderTop:"1px solid var(--border)"}}>
          <button onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page===1}
            style={{background:"none",border:"1px solid var(--border2)",color:page===1?"var(--text5)":"var(--text3)",padding:"6px 14px",fontSize:9,letterSpacing:2,cursor:page===1?"default":"pointer",borderRadius:2,fontFamily:"'Courier New',monospace"}}>
            ANTERIOR
          </button>
          <span style={{fontSize:9,letterSpacing:2,color:"var(--text4)",fontFamily:"'Courier New',monospace"}}>
            {page} / {totalPages} — {filtered.length} evento(s)
          </span>
          <button onClick={()=>setPage(p=>Math.min(totalPages,p+1))} disabled={page>=totalPages}
            style={{background:"none",border:"1px solid var(--border2)",color:page>=totalPages?"var(--text5)":"var(--text3)",padding:"6px 14px",fontSize:9,letterSpacing:2,cursor:page>=totalPages?"default":"pointer",borderRadius:2,fontFamily:"'Courier New',monospace"}}>
            PRÓXIMO
          </button>
        </div>
      )}
    </div>
  );
}

export default AuditoriaTab
